/**
 * @file
 * @author chenyaqiu@baidu.com
 */
import ColorPicker from './colorPicker';
export default ColorPicker;
